export enum MktButtonTypes {
  primary = 'primary',
  'secondary-light' = 'secondary-light',
  'secondary-dark' = 'secondary-dark',
  light = 'light',
}

export type MktButtonStylesType = {
  [key in MktButtonTypes]: string;
};

export interface MktButtonProps {
  children?: React.ReactNode;
  variant: `${MktButtonTypes}`;
  onClick: () => void;
}
